<template>
  <div id="calculate" :class="{'hashead':!isPC}">
    <Header v-if="isPC"></Header>
    <WapHeader v-if="!isPC" :title="'贷款计算器'" :showhome="$store.state.domainIndex==3"></WapHeader>
    <div class="box">
      <div :class="{'tabbox':isPC}">
        <div class="caltab clearfix">
          <span @click="toggle(0)" :class="{tabOn:tabCurr==0}">商业贷款</span>
          <span @click="toggle(1)" :class="{tabOn:tabCurr==1}">组合贷款</span>
          <span @click="toggle(2)" :class="{tabOn:tabCurr==2}">公积金贷款</span>
        </div>
        <div :class="{'tabcontent clearfix':isPC}">
          <div class="mbox">
            <span>计算方式</span>
            <div class="mf-fr">
              <span class="radio" :class="{'active':radioValue==1}" @click="radioClick(1)"><i class="m-icon"></i>按房价总额</span>
              <span class="radio" :class="{'active':radioValue==2}" @click="radioClick(2)"><i class="m-icon"></i>按贷款总额</span>
            </div>
          </div>
          <div class="mbox">
            <span v-if="radioValue==1">房屋总价</span>
            <span v-if="radioValue==2">贷款总价</span>
            <i v-if="isFocus" class="el-icon-warning"></i>
            <span class="unit mf-fr">万</span>
            <input type="number" id="total_sy" class="inputtxt mf-fr" placeholder="请输入" v-model="totalPriceVal" @change="changeClacPrice()"/>
          </div>
          <div class="mbox" v-if="radioValue==1">
            <span>贷款比例</span>
            <el-select v-model="porpVal" placeholder="请选择">
              <el-option v-for="(item,index) in propItems" :key="index" :label="item.label" :value="item.value" :change="changeClacPrice()"></el-option>
            </el-select>
          </div>
          <div class="mbox">
            <span>按揭年数</span>
            <el-select v-model="yearVal" placeholder="请选择">
              <el-option v-for="(item,index) in yearItems" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="mbox mtop" v-if="tabCurr==1">
            <span>公积金金额</span>
            <i v-if="isFocus1" class="el-icon-warning"></i>
            <span class="unit mf-fr">万</span>
            <input type="number" class="inputtxt mf-fr" placeholder="请输入" v-model="publicMoneyVal" @change="changeClacPrice()"/>
          </div>
          <div class="mbox" v-if="tabCurr==1||tabCurr==2">
            <span>公贷利率</span>
            <span class="mf-fr asInput">3.25%</span>
          </div>
          <div class="mbox mtop" v-if="tabCurr==1">
            <span>商贷金额</span>
            <span class="unit mf-fr">万</span>
            <input type="number" class="inputtxt mf-fr" placeholder="请输入" disabled="true" v-model="moneyVal"/>
          </div>
          <div class="mbox" v-if="tabCurr==0||tabCurr==1">
            <span>商贷利率</span>
            <el-select v-model="businessRateVal" placeholder="请选择">
              <el-option v-for="(item,index) in rateItems" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="mbox mtop">
            <span>还款方式</span>
            <div class="mf-fr">
              <span class="radio" :class="{'active':modeVal==1}" @click="radioClick1(1)"><i class="m-icon"></i>等额本息</span>
              <span class="radio" :class="{'active':modeVal==2}" @click="radioClick1(2)"><i class="m-icon"></i>等额本金</span>
            </div>
          </div>
          <div>
            <span class="mbutton" @click="submitSearch()">{{submitClac}}</span>
          </div>
          <div class="resultbox boxshadow" v-if="resultShow&&!isPC">
            <div class="top"><span>计算结果</span></div>
            <div class="row"><label>房贷总额</label><span class="zd"><b>{{resTotal}}</b>万元</span></div>
            <div class="row"><label>贷款期限</label><span class="qx">{{resYear}}</span></div>
            <div class="row" v-if="modeVal == 1"><label>参考月供</label><span class="yg">{{resReferences}}</span></div>
            <div class="row" v-if="modeVal == 2"><label>首月月供</label><span class="yg">{{resReferences}}</span></div>
            <div class="row" v-if="modeVal == 2"><label>每月递减</label><span class="dj">{{resDelMonth}}</span></div>
            <div class="row"><label>合计利息</label><span class="lx">{{resAllInterest}}</span></div>
            <div class="row"><label>本息合计</label><span class="bx">{{resInterest}}</span></div>
            <p class="rtips">以上结果仅供参考，请以实际结果为准。</p>
          </div>
          <div class="resultbox boxshadow" v-if="isPC">
            <div class="top"><span>计算结果</span></div>
            <div class="row"><label>房贷总额</label><span class="zd"><b>{{resTotal}}</b>万元</span></div>
            <div class="row"><label>贷款期限</label><span class="qx">{{resYear}}</span></div>
            <div class="row" v-if="modeVal == 1"><label>参考月供</label><span class="yg">{{resReferences}}</span></div>
            <div class="row" v-if="modeVal == 2"><label>首月月供</label><span class="yg">{{resReferences}}</span></div>
            <div class="row" v-if="modeVal == 2"><label>每月递减</label><span class="dj">{{resDelMonth}}</span></div>
            <div class="row"><label>合计利息</label><span class="lx">{{resAllInterest}}</span></div>
            <div class="row"><label>本息合计</label><span class="bx">{{resInterest}}</span></div>
            <p class="rtips">以上结果仅供参考，请以实际结果为准。</p>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/public/Header'
import WapHeader from '@/components/public/WapHeader'
import Footer from '@/components/public/Footer'

export default {
  name: 'Calculate',
  components:{
    'Header':Header,
    'WapHeader':WapHeader,
    'Footer': Footer,
  },
  data(){
    return {
      isPC:this.$store.state.isPC,
      tabCurr:0,
      propItems: [
        {value: '0.9',label: '9成'},
        {value: '0.8',label: '8成'},
        {value: '0.7',label: '7成'},
        {value: '0.6',label: '6成'},
        {value: '0.5',label: '5成'},
        {value: '0.4',label: '4成'},
        {value: '0.3',label: '3成'},
        {value: '0.2',label: '2成'},
        {value: '0.1',label: '1成'}
      ],
      yearItems: [
        {value: '36',label: '3年(36期)'},
        {value: '48',label: '4年(48期)'},
        {value: '60',label: '5年(60期)'},
        {value: '72',label: '6年(72期)'},
        {value: '84',label: '7年(84期)'},
        {value: '96',label: '8年(96期)'},
        {value: '108',label: '9年(108期)'},
        {value: '120',label: '10年(120期)'},
        {value: '132',label: '11年(132期)'},
        {value: '144',label: '12年(144期)'},
        {value: '156',label: '13年(156期)'},
        {value: '168',label: '14年(168期)'},
        {value: '180',label: '15年(180期)'},
        {value: '192',label: '16年(192期)'},
        {value: '204',label: '17年(204期)'},
        {value: '216',label: '18年(216期)'},
        {value: '228',label: '19年(228期)'},
        {value: '240',label: '20年(240期)'},
        {value: '300',label: '25年(300期)'},
        {value: '360',label: '30年(360期)'}
      ],
      rateItems: [
        {value: '0.049',label: '基准利率(4.9%)'},
        {value: '0.0588',label: '4.9%*1.2倍'},
        {value: '0.0539',label: '4.9%*1.1倍'},
        {value: '0.0441',label: '4.9%*9.0折'},
        {value: '0.0392',label: '4.9%*8.0折'},
        {value: '0.0343',label: '4.9%*7.0折'}
      ],
      radioValue: '1',            //计算方式：1=>按房价总额, 2=>按贷款总额
      totalPriceVal: '',          //房款总价/贷款总价
      publicMoneyVal: '0',        //公积金金额
      moneyVal: '',               //商贷金额
      porpVal: '0.7',             //贷款比例
      yearVal: '360',             //按揭年数
      rateVal: '0.049',           //计算时利率
      businessRateVal: '0.049',   //商贷利率
      publicRateVal: '0.0325',    //公积金利率
      modeVal: '1',               //还款方式：1=>等额本息, 2=>等额本金
      resTotal: '0',              //房贷总额
      resYear: '0年',              //贷款期限
      resReferences: '0元/月', //参考月供=>等额本息
      resDelMonth:'0元/月',    //每月递减=>等额本金
      resAllInterest:'0万元',  //合计利息
      resInterest:'0万元',     //本息合计
      submitClac: '立即提交',
      resultShow: false,
      isFocus:false,
      isFocus1:false,
    }
  },
  computed:{
    listenIsPC(){
      return this.$store.state.isPC;
    }
  },
  watch:{
    listenIsPC:function(boo){
      this.isPC = this.$store.state.isPC;
    }
  },
  methods:{
    toggle(i){
      this.tabCurr=i;
      if(this.tabCurr==0){
        this.rateVal=this.businessRateVal
      }else if(this.tabCurr==2){
        this.rateVal=this.publicRateVal
      }
      this.resultShow=false;
      this.resTotal='0';
      this.resYear='0年';
      this.resReferences='0元/月';
      this.resDelMonth='0元/月';
      this.resAllInterest='0万元';
      this.resInterest='0万元';
      this.submitClac='立即提交';
    },
    radioClick(index){
      this.radioValue=index;
      this.changeClacPrice();
    },
    radioClick1(index){
      this.modeVal=index;
      this.submitSearch();
    },
    changeClacPrice(){
      if(this.radioValue == 1){
        //商贷金额=(房价总额*贷款比例-公积金金额)
        this.moneyVal = this.totalPriceVal * this.porpVal - this.publicMoneyVal;
      }else{
        this.moneyVal = Number(this.totalPriceVal - this.publicMoneyVal);
      }
    },
    submitSearch:function(){
      if(this.totalPriceVal == "" || this.totalPriceVal < 0){
        // alert('请输入房屋总价');
        this.isFocus=true;
        this.resultShow = false;
        return;
      }
      this.isFocus=false;
      if(this.tabCurr==1&&(this.publicMoneyVal<0 || this.moneyVal<0)){
        //alert('请输入有效的公积金贷款，商业贷款会自动计算');
        this.isFocus1=true;
        this.resultShow = false;
        return;
      }
      this.isFocus1=false;
      this.resultShow = true;
      this.submitClac = '重新计算';
      if(this.radioValue == 1){//房贷总额=总价*贷款比例
        this.resTotal = (this.totalPriceVal*this.porpVal).toFixed(2); 
      }else{//按贷款总额
        this.resTotal = this.totalPriceVal;
      }
      if(this.tabCurr==1){
        var l_gjj=Number(this.publicMoneyVal),    //公积金贷款总额
            l_sy=Number(this.moneyVal),       //商业贷款总额
            r_gjj=Number(this.publicRateVal/12),  //公积金月利率
            r_sy=Number(this.rateVal/12),     //商贷月利率
            t=Number(this.yearVal),         //还款月数
            w=Number(this.modeVal),         //还款方式
            m_gjj=0,      //每月还款
            m_sy=0,       //每月还款
            m1_gjj=0,     //每月递减
            m1_sy=0,      //每月递减
            a_gjj=0,      //利息
            a_sy=0,       //利息
            d=0;        //本息
        if(w==1){ //等额本息
          m_gjj=Number((l_gjj*r_gjj*Math.pow((1+r_gjj),t))/(Math.pow((1+r_gjj),t)-1));
          a_gjj=Number((t*m_gjj-l_gjj).toFixed(2));
          m_sy=Number((l_sy*r_sy*Math.pow((1+r_sy),t))/(Math.pow((1+r_sy),t)-1));
          a_sy=Number((t*m_sy-l_sy).toFixed(2));
        }else{    //等额本金
          m_gjj=Number((l_gjj/t)+(l_gjj*r_gjj));
          m1_gjj=Number(l_gjj/t*r_gjj);
          a_gjj=Number(((m_gjj+l_gjj/t*(1+r_gjj))/2*t-l_gjj).toFixed(2));
          m_sy=Number((l_sy/t)+(l_sy*r_sy));
          m1_sy=Number(l_sy/t*r_sy);
          a_sy=Number(((m_sy+l_sy/t*(1+r_sy))/2*t-l_sy).toFixed(2));
        }
        d=Number(a_gjj+l_gjj+a_sy+l_sy).toFixed(2);
        var m=((m_gjj+m_sy)*10000).toFixed(2);
        var m1=((m1_gjj+m1_sy)*10000).toFixed(2);
        var a=Number((a_gjj+a_sy).toFixed(2));
        this.resTotal = l_gjj+l_sy;   //房贷总额
      }else{
        var l=Number(this.resTotal),  //房贷总额
            r=Number(this.rateVal/12),  //月利率=>商贷利率
            t=Number(this.yearVal),   //还款月数=>按揭年数
            w=Number(this.modeVal),   //还款方式
            m=0,            //每月还款
            m1=0,           //每月递减
            a=0,            //利息
            d=0;            //本息
        if(w==1){ //等额本息
          m=Number((l*r*Math.pow((1+r),t))/(Math.pow((1+r),t)-1));
          a=Number((t*m-l).toFixed(2));
        }else{    //等额本金
          m=Number((l/t)+(l*r));
          m1=Number(l/t*r);
          a=Number(((m+l/t*(1+r))/2*t-l).toFixed(2));
        }
        d=(a+l).toFixed(2);
        m=(m*10000).toFixed(2);
        m1=(m1*10000).toFixed(2);
        this.resTotal = l;        //房贷总额
      }
      this.resYear = t/12+'年';    //贷款期限
      this.resReferences = m+'元/月'; //参考月供
      this.resDelMonth = m1+'元/月';  //每月递减=>等额本金
      this.resAllInterest = a+'万元'; //合计利息
      this.resInterest = d+'万元';    //本息合计
    },
  }
}
</script>
<style scoped>
#calculate{padding-bottom:20px;}
.caltab{background:#fff;position:relative;z-index:1;font-size:15px;}
.caltab span{display:inline-block;}
.unit{ margin-left:7px;}
select{outline:0;-webkit-appearance:none;resize:none}
.modebox input{float: right;}
.resultbox{margin:15px 15px 0;background:#fff;line-height:21px;padding:15px;overflow:hidden}
.resultbox .top{padding:10px 0;border-bottom:1px solid #e7e7e7;margin-bottom:15px}
.resultbox .row{padding:4px 0;color:#444}
.resultbox .row label{color:#999}
.resultbox .row span{float:right}
.resultbox .row b{font-weight:400}
.resultbox .row .zd{float:none;display:block;font-size:18px;line-height:22px;padding:10px 0 7px;margin-top:7px;position:relative}
.resultbox .row .zd:before{content:"";display:block;width:20px;height:3px;background:#ffd800;position:absolute;top:0;left:0}
.resultbox .rtips{font-size:12px;padding:10px 0;color:#999}
.mbutton{width:200px;margin:30px auto;}
.radio{color:#999;cursor:pointer;}
.radio+.radio{margin-left:15px;}
.radio .m-icon{margin-top:2px;}
.radio.active{color:#333;}
.radio.active .m-icon{margin-top:1px;}
.el-select{margin-top:-10px;width:auto;margin-right:-10px;}
.inputtxt{background:0 0;font-size:14px;}
.el-icon-warning{color:#FF5722;}
@media (max-width:768px){
  .caltab{padding:0 20px;text-align:center;box-shadow:0 2px 5px #eaeaea;}
  .caltab span{color:#999;line-height:50px;height:50px;padding:0 10px;}
  .caltab span:first-child{position:absolute;left:20px;top:0;}
  .caltab span:first-child+span+span{position:absolute;right:20px;top:0;}
  .caltab .tabOn{color:#2e303a;position:relative;}
  .tabOn:after{content:"";border-bottom:3px solid #ffd03d;position:absolute;left:0;right:0;bottom:0;}
  .mtop{margin-top:15px;}
  .mbox{background:#fff;position:relative;padding:15px 15px;border-top:1px solid #e7e7e7;border-bottom:1px solid #e7e7e7;line-height:20px}
  .mbox+.mbox:not(.mtop){border-top:0;}
  .mf-fr,.el-select{float:right;}
  .inputtxt{line-height:20px;width:68%;text-align:right;color:#444}
  #calculate >>> .el-input__inner{text-align:right;border:0;padding-left:0;color:#333;font-size:14px;}
}
@media (min-width:769px){
  .tabbox{border:1px solid #dcdfe6;box-shadow:0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);margin:30px 0;}
  .caltab{background:#f5f7fa;border-bottom:1px solid #e4e7ed;line-height:40px;height:42px;}
  .caltab span{padding:0 15px;border: 1px solid transparent;margin-left:-1px;cursor:pointer;}
  .caltab .tabOn{color:#2e303a;background:#fff;border-right-color:#dcdfe6;border-left-color:#dcdfe6;margin-bottom:-1px;height:41px;}
  .tabcontent{padding:20px 50% 20px 30px;position:relative;min-height:350px}
  .resultbox{position:absolute;left:50%;top:20px;width:280px;margin-left:5%}
  .mbox{padding:4px 0;line-height:40px;height:40px;position:relative;padding-left:90px;float:right;width:240px;}
  .mbox>span:first-child{position:absolute;left:0;top:4px;}
  .mbox>span:first-child:after{content:"： ";}
  .mf-fr,.el-select{display:inline-block;}
  .el-select{width:220px;}
  .radio .m-icon{margin-top:13px;}
  .radio.active .m-icon{margin-top:12px;}
  .inputtxt,.asInput{border:1px solid #DCDFE6;line-height:20px;height:20px;border-radius:4px;padding:9px 40px 9px 15px;width:163px;float:left;}
  .unit{margin-left:-30px;}
  .mbutton{width:220px;border-radius:5px;float:right;margin-right:20px;margin-top:20px;}
  .el-icon-warning{position:absolute;right:0;top:17px;}
}
</style>
<style>
.el-popper[x-placement^=bottom]{margin-top:3px;}
.el-popper[x-placement^=top]{margin-bottom:3px;}
.el-popper .popper__arrow{right:7px;left:auto!important}
</style>


// WEBPACK FOOTER //
// src/components/Calculate.vue